import axios from 'axios';

var baseUrl
baseUrl = (window.location.hostname.includes('localhost'))
        ? `https://coopharma-api-zd5is.ondigitalocean.app/api`
        : `https://coopharma-api-zd5is.ondigitalocean.app/api`

const fetchData = async (url) => {
	try {
		const configuration = {
			method: 'get',
			url: `${baseUrl}` + url,
			headers:{
				'x-access-token': `${localStorage.getItem('token')}`
			}
		};

		const response = await axios(configuration);
		return response.data;
	} catch (error) {
		return error.response.data;
	}
};

const sendData = async (url, data) => {
	try {
		const configuration = {
			method: 'post',
			url: `${baseUrl}` + url,
			data: data,
			headers:{
				'x-access-token': `${localStorage.getItem('token')}`
			}
		};

		const response = await axios(configuration);
		return response.data;
	} catch (error) {
		console.log(error)
		return error.response.data
	}
};

const sendDataPut = async (url, data) => {
	try {
		const configuration = {
			method: 'put',
			url: `${baseUrl}` + url,
			data: data,
			headers:{
				'x-access-token': `${localStorage.getItem('token')}`
			}
		};

		const response = await axios(configuration);
		return response.data;
	} catch (error) {
		return error.response.data;
	}
};

const sendDataDelete = async (url) => {
	try {
		const configuration = {
			method: 'post',
			url: `${baseUrl}` + url,
			headers:{
				'x-access-token': `${localStorage.getItem('token')}`
			}
		};
		const response = await axios(configuration);
		return response.data;
	} catch (error) {
		return error.response.data;
	}
};

const sendDataOherUrl = async (url, data) => {
	try {
		const configuration = {
			method: 'post',
			url: url,
			data: data,
			headers:{
				'x-access-token': `${localStorage.getItem('token')}`
			}
		};

		const response = await axios(configuration);
		return response.data;
	} catch (error) {
		return error.response.data;
	}
};

export { fetchData, sendData, sendDataPut, sendDataOherUrl, sendDataDelete };
